import { useEffect, useState } from "react";
import { Check, Sparkles } from "./icons";

/**
 * ภาพเคลื่อนไหวระหว่างรอ AI สร้างแม่แบบเอกสาร (ADR-0028) — งานนี้ใช้เวลาหลายสิบวินาที จอเงียบ ๆ
 * ทำให้ผู้ใช้คิดว่าค้าง: กระดาษที่มีแสงสแกนวิ่ง + ขั้นตอนที่ไล่ไปตามเวลา + เวลาที่ผ่านไป
 *
 * ขั้นตอนเป็นการประมาณจากเวลาเท่านั้น (server ไม่ได้รายงานความคืบหน้าจริง) จึงไม่มีเปอร์เซ็นต์
 * และขั้นสุดท้ายค้างไว้จนกว่าจะเสร็จจริง · prefers-reduced-motion = ไม่มีแสงวิ่ง/กะพริบ (index.css)
 */
const STEPS: { from: number; label: string }[] = [
  { from: 0, label: "ອ່ານໄຟລ໌ຕົວຢ່າງ" },
  { from: 8, label: "ຈັດໂຄງສ້າງເອກະສານ" },
  { from: 25, label: "ກຳນົດຊ່ອງທີ່ຜູ້ຮ້ອງຕ້ອງກອກ" },
  { from: 50, label: "ກຽມຮ່າງ ແລະ ຕົວຢ່າງ" },
];

export function AiWorking({ title }: { title: string }) {
  const [elapsed, setElapsed] = useState(0);
  useEffect(() => {
    const start = Date.now();
    const t = setInterval(() => setElapsed(Math.floor((Date.now() - start) / 1000)), 1000);
    return () => clearInterval(t);
  }, []);
  const current = STEPS.reduce((at, s, i) => (elapsed >= s.from ? i : at), 0);

  return (
    <div className="ai-working" role="status" aria-live="polite">
      <div className="ai-working__paper" aria-hidden="true">
        <span className="ai-working__line ai-working__line--title" />
        <span className="ai-working__line" />
        <span className="ai-working__line ai-working__line--short" />
        <span className="ai-working__line" />
        <span className="ai-working__line" />
        <span className="ai-working__line ai-working__line--short" />
        <span className="ai-working__beam" />
        <span className="ai-working__badge">
          <Sparkles size={18} />
        </span>
      </div>
      <p className="ai-working__title">{title}</p>
      <ol className="ai-working__steps">
        {STEPS.map((s, i) => (
          <li key={s.label} className={i < current ? "is-done" : i === current ? "is-active" : ""}>
            <span className="ai-working__dot" aria-hidden="true">
              {i < current ? <Check size={11} /> : null}
            </span>
            {s.label}
          </li>
        ))}
      </ol>
      <p className="caption">
        ຜ່ານໄປ <span className="num">{elapsed}</span> ວິນາທີ · ປົກກະຕິ 30–90 ວິນາທີ — ຢ່າປິດໜ້ານີ້
      </p>
    </div>
  );
}
